import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetTicketsConfig = () =>
  useMutation({
    mutationFn: (ticketsType) =>
      client(`dynamic/filtering/config/${ticketsType}`),
  });

export const useGetTicketsQuery = () =>
  useMutation({
    mutationFn: (data) =>
      client(`dynamic/filtering/allcalls/search`, {
        data,
      }),
  });
export const useExportTicketsQuery = () =>
  useMutation({
    mutationFn: (data) =>
      client(`dynamic/filtering/allcalls/search/export`, {
        data,
      }),
  });
export const useSaveTicketsQuery = () =>
  useMutation({
    mutationFn: (data) =>
      client("dynamic/filtering/searchcriteria/user/save", {
        data,
        successMessage: "Query has been saved successfully",
      }),
  });
export const useGetSavedCriteria = () =>
  useMutation({
    mutationFn: (ticketsType) =>
      client(`dynamic/filtering/searchcriteria/user/all/${ticketsType}`),
  });
export const useGetSavedCriteriaDetails = () =>
  useMutation({
    mutationFn: (name) =>
      client(`dynamic/filtering/searchcriteria/user/${name}`),
  });

export const useGetAvailableColumns = () =>
  useMutation({
    mutationFn: (ticketsType) =>
      client(`dynamic/filtering/available/columns/${ticketsType}`),
  });
export const useGetUserColumns = () =>
  useMutation({
    mutationFn: (ticketsType) =>
      client(`dynamic/filtering/user/columns/${ticketsType}`),
  });
export const useUpdateUserColumns = () =>
  useMutation({
    mutationFn: (data) =>
      client(`dynamic/filtering/user/columns/save`, {
        data,
        successMessage: "Columns updated successfully!",
      }),
  });

export const useGetDefaultSettings = () =>
  useMutation({
    mutationFn: (ticketsType) =>
      client(`dynamic/filtering/default/settings/${ticketsType}`),
  });
export const useGetUserSettings = () =>
  useMutation({
    mutationFn: (ticketsType) =>
      client(`dynamic/filtering/user/settings/${ticketsType}`),
  });
export const useUpdateUserSettings = () =>
  useMutation({
    mutationFn: (data) =>
      client(`dynamic/filtering/user/settings/save`, {
        data,
        successMessage: "Settings updated successfully!",
      }),
  });
export const useDeleteSearchCriteria = () =>
  useMutation({
    mutationFn: (id) =>
      client(`dynamic/filtering/searchcriteria/user/${id}`, {
        method: "delete",
        successMessage: "Query has been deleted successfully!",
      }),
  });
export const useUpdateSearchCriteriaSequence = () =>
  useMutation({
    mutationFn: (data) =>
      client(`dynamic/filtering/searchcriteria/user/change/order`, {
        data,
        successMessage: "Sequence updated successfully!",
      }),
  });

export const useGetTasksQuery = () =>
  useMutation({
    mutationFn: (data) =>
      client(`dynamic/filtering/tasks/search`, {
        data,
      }),
  });
export const useExportTasksQuery = () =>
  useMutation({
    mutationFn: (data) =>
      client(`dynamic/filtering/tasks/search/export`, {
        data,
      }),
  });
